module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom13.c6b16008.jpg";